module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.b1e10622.ttf";